import React, { Component } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { THEME, INIT_LECTURE_FORM, MOCK_CHAPTERS, MOCK_TOPICS } from "./lectureLibraryConstants";
import { validateLectureForm } from "./lectureLibraryValidation";
import { INIT_R2_UPLOAD, CONFIRM_R2_UPLOAD, FILE_UPLOAD, CREATE_LECTURE_VIDEO, UPDATE_LECTURE_VIDEO, GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR } from "./lectureLibraryService";
// Local CheckboxDropdown for Branch multi-selection (matches studentDiary & expenseManagement styling)
class CheckboxDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.ref = React.createRef();
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutside);
  }
  handleOutside = (e) => {
    if (this.ref.current && !this.ref.current.contains(e.target)) {
      this.setState({ open: false });
    }
  };
  toggle = (id) => {
    const { value, onChange } = this.props;
    const exists = value.includes(id);
    onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
  };
  render() {
    const { options, value, placeholder, onChange } = this.props;
    const { open } = this.state;
    const label = value.length === 0
      ? placeholder
      : value.length === options.length
        ? `All (${options.length})`
        : value.length === 1
          ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
          : `${value.length} selected`;
    return (
      <div ref={this.ref} style={{ position: "relative" }}>
        <div
          onClick={() => this.setState({ open: !open })}
          style={{
            borderRadius: 8,
            border: "1.5px solid #e2e8f0",
            padding: "10px 12px",
            fontSize: "13px",
            color: value.length ? "#1f2937" : "#9ca3af",
            background: "#ffffff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            userSelect: "none",
            height: "44px"
          }}
        >
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
          <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
        </div>
        {open && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1.5px solid #e2e8f0",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              zIndex: 999,
              maxHeight: 200,
              overflowY: "auto"
            }}
          >
            {options.length === 0 ? (
              <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
            ) : (
              <>
                <div
                  onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                  style={{
                    padding: "8px 12px",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#6366f1",
                    cursor: "pointer",
                    borderBottom: "1px solid #f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                >
                  <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                  Select All
                </div>
                {options.map((o) => (
                  <div
                    key={o.value}
                    onClick={() => this.toggle(o.value)}
                    style={{
                      padding: "7px 12px",
                      fontSize: 13,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: value.includes(o.value) ? "#f5f3ff" : "transparent",
                      borderBottom: "1px solid #f9fafb"
                    }}
                  >
                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}
class LectureUpload extends Component {
  constructor(props) {
    super(props);
    const { editItem } = props;
    // Load initial form
    let initialForm = { ...INIT_LECTURE_FORM };
    let inferredBranchId = "";
    if (editItem && editItem.class_id && props.branches) {
      const branch = props.branches.find(b =>
        b.sections && b.sections.some(s => String(s.class_id) === String(editItem.class_id))
      );
      if (branch) inferredBranchId = branch.id;
    }
    if (editItem) {
      initialForm = {
        id: editItem.id,
        video_category_id: editItem.video_category_id ? parseInt(editItem.video_category_id) : "",
        video_sub_category_id: editItem.video_sub_category_id ? parseInt(editItem.video_sub_category_id) : "",
        paid_video: editItem.paid_video ? parseInt(editItem.paid_video) : 0,
        lecturer_id: editItem.lecturer_id || "",
        branch_id: inferredBranchId, // Inferred from class mapping
        class_id: editItem.class_id || "",
        subject_id: editItem.subject_id ? parseInt(editItem.subject_id) : "",
        title: editItem.title || "",
        description: editItem.description || "",
        video_url: editItem.video_url || "",
        publish: editItem.publish ? parseInt(editItem.publish) : 1,
        doc_file: editItem.doc_file || "",
        video_date: editItem.video_date || new Date().toLocaleDateString("en-CA"),
        estatus: editItem.estatus ? parseInt(editItem.estatus) : 1,
      };
    }
    this.state = {
      formData: initialForm,
      errors: {},
      saving: false,
      // Video File Upload State
      videoFile: null,
      videoPreviewUrl: null,
      videoDragOver: false,
      videoUploadProgress: null,
      abortController: null,
      // Doc File Upload State
      docUploading: false,
      docFileObject: null,
      dynamicSubjects: [],
    };
  }
  componentDidMount() {
    if (this.state.formData.class_id) {
      this.fetchSubjects(this.state.formData.class_id);
    }
  }
  componentWillUnmount() {
    // Abort any in-progress video upload
    if (this.state.abortController) {
      this.state.abortController.abort();
    }
    // Revoke any object URL to prevent memory leak
    if (this._videoPreviewUrl) {
      URL.revokeObjectURL(this._videoPreviewUrl);
    }
  }
  fetchSubjects = async (class_id) => {
    if (!class_id || !this.props.academicYearId) {
      this.setState({ dynamicSubjects: [] });
      return;
    }
    try {
      const res = await this.props.client.query({
        query: GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR,
        variables: {
          academic_year_id: parseInt(this.props.academicYearId),
          classIds: String(class_id),
          institute_id: parseInt(this.props.instituteId)
        },
        fetchPolicy: "network-only",
      });
      const apiData = res.data?.getClassSubjectsByAcademicYear || [];
      if (apiData.length > 0 && apiData[0].subject_ids) {
        const parseCsv = (val) => String(val || "").split(",").map((s) => s.trim()).filter(Boolean);
        const isCheckedValue = (value) => {
          if (value === true || value === 1) return true;
          const normalized = String(value ?? "").trim().toLowerCase();
          return normalized === "true" || normalized === "1";
        };
        const subjectIds = parseCsv(apiData[0].subject_ids);
        const subjectNames = parseCsv(apiData[0].subject_names);
        const checkedValues = parseCsv(apiData[0].checked);
        const subjects = subjectIds.map((id, idx) => ({
          id: parseInt(id, 10),
          subject: subjectNames[idx] || id,
          checked: checkedValues.length ? isCheckedValue(checkedValues[idx]) : false,
        })).filter(s => s.checked).map(s => ({ id: s.id, subject: s.subject }));
        this.setState({ dynamicSubjects: subjects });
      } else {
        this.setState({ dynamicSubjects: [] });
      }
    } catch (err) {
      console.warn("Could not query subjects dynamically.", err);
    }
  };
  //  Dropdowns & Sub-data Getters 
  getFilteredSubCategories = () => {
    const { subcategories } = this.props;
    const { formData } = this.state;
    if (!formData.video_category_id) return [];
    return subcategories.filter(
      (sub) => Number(sub.video_category_id) === Number(formData.video_category_id)
    );
  };
  getFilteredSubjects = () => {
    return this.state.dynamicSubjects;
  };
  getFilteredLecturers = () => {
    const { lecturers } = this.props;
    const { formData } = this.state;
    if (!formData.subject_id) return [];
    // Filter lecturers assigned to this subject
    return lecturers.filter((l) => {
      if (l.subject_ids) {
        const ids = String(l.subject_ids).split(",").map(id => id.trim());
        return ids.includes(String(formData.subject_id));
      }
      return false; // Only show lecturers explicitly mapped to this subject
    });
  };
  getFilteredClasses = () => {
    const { classes, branches } = this.props;
    const { formData } = this.state;
    if (!formData.branch_id) return [];
    const branch = branches.find(b => String(b.id) === String(formData.branch_id));
    if (!branch || !branch.sections) return [];
    const allowedClassIds = branch.sections.map(s => String(s.class_id));
    return classes.filter(c => allowedClassIds.includes(String(c.id)));
  };
  //  Input Handling 
  handleFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prev) => {
        let updatedForm = { ...prev.formData, [name]: value };
        let updatedErrors = { ...prev.errors };
        delete updatedErrors[name];
        if (name === "video_category_id") {
          updatedForm.video_sub_category_id = "";
        }
        if (name === "branch_id") {
          updatedForm.class_id = "";
          updatedForm.subject_id = "";
          updatedForm.lecturer_id = "";
          this.setState({ dynamicSubjects: [] });
        }
        if (name === "class_id") {
          updatedForm.subject_id = "";
          updatedForm.lecturer_id = "";
          this.fetchSubjects(value);
        }
        if (name === "subject_id") {
          updatedForm.lecturer_id = "";
        }
        return { formData: updatedForm, errors: updatedErrors };
      }
    );
  };
  handleCheckboxDropdownChange = (name, selectedValues) => {
    this.setState((prev) => {
      let updatedErrors = { ...prev.errors };
      delete updatedErrors[name];
      return {
        formData: {
          ...prev.formData,
          [name]: selectedValues,
        },
        errors: updatedErrors,
      };
    });
  };
  //  Video Uploader (R2 direct PUT) 
  handleVideoDragOver = (e) => {
    e.preventDefault();
    this.setState({ videoDragOver: true });
  };
  handleVideoDragLeave = () => {
    this.setState({ videoDragOver: false });
  };
  handleVideoDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer?.files?.[0] || e.target?.files?.[0];
    if (file) {
      if (!file.type.startsWith("video/")) {
        alert("Please drop a valid video file.");
        return;
      }
      // Revoke old URL if it exists in state
      if (this.state.videoPreviewUrl) {
        URL.revokeObjectURL(this.state.videoPreviewUrl);
      }
      const newPreviewUrl = URL.createObjectURL(file);
      this.setState((prev) => {
        let updatedErrors = { ...prev.errors };
        delete updatedErrors.video_url;
        return {
          videoFile: file,
          videoPreviewUrl: newPreviewUrl,
          videoDragOver: false,
          errors: updatedErrors
        };
      });
    }
  };
  uploadVideoToR2 = async () => {
    const { videoFile } = this.state;
    const { client, instituteId } = this.props;
    if (!videoFile) return true; // If no file, consider it successful so form can proceed (e.g. for edit mode)
    const abortController = new AbortController();
    this.setState((prev) => {
      let updatedErrors = { ...prev.errors };
      delete updatedErrors.video_url;
      return { videoUploadProgress: 0, abortController, errors: updatedErrors };
    });
    try {
      // 1. Initialize R2 Upload
      const initResult = await client.mutate({
        mutation: INIT_R2_UPLOAD,
        variables: {
          params: {
            filename: videoFile.name,
            content_type: videoFile.type || "video/mp4",
            institute_id: instituteId,
          },
        },
      });
      const { presigned_url, r2_key } = initResult.data.initR2VideoUpload;
      // 2. Direct PUT to Cloudflare R2 Bucket
      await axios.put(presigned_url, videoFile, {
        headers: {
          "Content-Type": videoFile.type || "video/mp4",
        },
        signal: abortController.signal,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.setState({ videoUploadProgress: percentCompleted });
        },
      });
      // 3. Update local state â€” keep videoFile so preview stays, set video_url
      this.setState((prev) => {
        let updatedErrors = { ...prev.errors };
        delete updatedErrors.video_url;
        return {
          formData: {
            ...prev.formData,
            video_url: `https://pub-39597fe6fc23495388bec8b4f1565d84.r2.dev/${r2_key}`,
          },
          videoUploadProgress: 100,
          abortController: null,
          errors: updatedErrors,
        };
      });
      // Confirm to R2 Logs
      try {
        await client.mutate({
          mutation: CONFIRM_R2_UPLOAD,
          variables: {
            params: {
              r2_key,
              title: this.state.formData.title || videoFile.name,
              description: this.state.formData.description || "",
              file_size: videoFile.size,
              institute_id: instituteId,
            },
          },
        });
      } catch (err) {
        console.warn("R2 Confirm mutation skipped/failed:", err.message);
      }
      return true; // Success flag for handleSubmit
    } catch (err) {
      if (axios.isCancel(err) || err.name === "CanceledError" || err.message === "canceled") {
        console.log("Upload cancelled by user.");
        this.setState({ videoUploadProgress: null, abortController: null });
        return false;
      }
      console.error("Video upload failed:", err);
      alert("Failed to upload the video: " + err.message);
      this.setState({ videoUploadProgress: null, abortController: null });
      return false;
    }
  };
  cancelVideoUpload = () => {
    if (this.state.abortController) {
      this.state.abortController.abort();
    }
  };
  //  PDF / Notes Uploader (Direct Base64) 
  handleDocFileChange = async (e) => {
    const file = e.target?.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert("File size exceeds the 5MB limit.");
      return;
    }
    this.setState({ docFileObject: file });
  };
  removeDocFile = () => {
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        doc_file: "",
      },
      docFileObject: null,
    }));
  };
  //  Form submission and CRUD 
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData } = this.state;
    const { client, instituteId, userId, onSuccess } = this.props;
    const errors = validateLectureForm(formData);
    // If video file is selected but not yet uploaded to R2, show a specific error
    if (this.state.videoFile && !formData.video_url) {
      errors.video_url = "Please upload the video first";
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    // Block submit if video upload is in progress
    if (this.state.videoUploadProgress !== null && this.state.videoUploadProgress < 100) {
      this.setState({ errors: { ...errors, submit: "Please wait for the video upload to finish before submitting." } });
      return;
    }
    this.setState({ saving: true });
    // Handle deferred document upload
    if (this.state.docFileObject) {
      try {
        const base64Data = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(this.state.docFileObject);
        });
        const docResponse = await client.mutate({
          mutation: FILE_UPLOAD,
          variables: {
            params: {
              category: "materials", // Supported backend category for documents
              client_id: instituteId,
              file: [{ img: base64Data, filename: this.state.docFileObject.name }]
            }
          }
        });
        const docResult = docResponse.data.fileUpload[0];
        if (docResult) {
          // Temporarily update formData state before dispatching main mutation
          await new Promise((resolve) => {
            this.setState((prev) => ({
              formData: {
                ...prev.formData,
                doc_file: docResult.file_url,
              }
            }), resolve);
          });
        }
      } catch (err) {
        console.error("Document upload failed:", err);
        alert("Failed to upload the attached notes document: " + err.message);
        this.setState({ saving: false });
        return;
      }
    }
    // Refresh formData reference to get newly injected video_url or doc_file
    const currentFormData = this.state.formData;
    // Payload preparation
    const input = {
      id: currentFormData.id,
      video_category_id: String(currentFormData.video_category_id),
      video_sub_category_id: String(currentFormData.video_sub_category_id),
      paid_video: parseInt(currentFormData.paid_video, 10) || 0,
      lecturer_id: currentFormData.lecturer_id,
      institute_id: instituteId,
      branch_ids: String(currentFormData.branch_id),
      class_id: currentFormData.class_id,
      subject_id: parseInt(currentFormData.subject_id, 10),
      title: currentFormData.title,
      description: currentFormData.description,
      video_url: currentFormData.video_url,
      publish: parseInt(currentFormData.publish, 10) || 0,
      doc_file: currentFormData.doc_file,
      video_date: currentFormData.video_date,
      inserted_by: userId,
      updated_by: userId,
    };
    try {
      if (formData.id) {
        // Update Video
        await client.mutate({
          mutation: UPDATE_LECTURE_VIDEO,
          variables: { input },
        });
        alert("Lecture Video updated successfully!");
      } else {
        // Create Video
        await client.mutate({
          mutation: CREATE_LECTURE_VIDEO,
          variables: { input },
        });
        alert("Lecture Video uploaded successfully!");
      }
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Failed to save lecture video: " + err.message);
    } finally {
      this.setState({ saving: false });
    }
  };
  handleReset = () => {
    const { editItem } = this.props;
    let resetForm = { ...INIT_LECTURE_FORM };
    if (editItem) {
      resetForm = {
        id: editItem.id,
        video_category_id: editItem.video_category_id ? parseInt(editItem.video_category_id) : "",
        video_sub_category_id: editItem.video_sub_category_id ? parseInt(editItem.video_sub_category_id) : "",
        paid_video: editItem.paid_video ? parseInt(editItem.paid_video) : 0,
        lecturer_id: editItem.lecturer_id || "",
        class_id: editItem.class_id || "",
        subject_id: editItem.subject_id ? parseInt(editItem.subject_id) : "",
        title: editItem.title || "",
        description: editItem.description || "",
        video_url: editItem.video_url || "",
        publish: editItem.publish ? parseInt(editItem.publish) : 1,
        doc_file: editItem.doc_file || "",
        video_date: editItem.video_date || new Date().toLocaleDateString("en-CA"),
        estatus: editItem.estatus ? parseInt(editItem.estatus) : 1,
      };
    }
    // Cleanup dangling object url
    if (this.state.videoPreviewUrl) {
      URL.revokeObjectURL(this.state.videoPreviewUrl);
    }
    this.setState({
      formData: resetForm,
      errors: {},
      videoFile: null,
      videoPreviewUrl: null,
      videoUploadProgress: null,
      docFileObject: null,
    });
  };
  render() {
    const { categories, classes, lecturers, branches, editItem, onCancel } = this.props;
    const { formData, errors, saving, videoUploadProgress, docUploading, docFileObject } = this.state;
    const labelStyle = { fontSize: "12px", fontWeight: "600", color: THEME.textMuted, marginBottom: "6px", display: "block" };
    const inputStyle = { border: `1px solid ${THEME.border}`, borderRadius: "8px", padding: "10px 14px", fontSize: "13px", color: THEME.text, transition: "border-color 0.15s ease-in-out", height: "44px" };
    const filteredSubCategories = this.getFilteredSubCategories();
    const filteredSubjects = this.getFilteredSubjects();
    const filteredLecturers = this.getFilteredLecturers();
    return (
      <div style={{ padding: "8px 0" }}>
        <Form onSubmit={this.handleSubmit}>
          <Row>
            {/* Left Column - Core Content (Media & Details) */}
            <Col lg={7} md={7} className="pr-lg-4">
              <div className="mb-4 d-flex align-items-center">
                <div style={{ background: "#eff6ff", color: "#4f46e5", width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                  <i className="fal fa-file-invoice" style={{ fontSize: "16px" }} />
                </div>
                <h6 style={{ margin: 0, fontWeight: "800", color: "#111827", fontSize: "15px" }}>Lecture Content</h6>
              </div>
              <Row>
                {/* 7. Title */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Video Title *</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    maxLength={100}
                    placeholder="e.g. Definite Integrals "
                    style={inputStyle}
                    value={formData.title}
                    onChange={this.handleFieldChange}
                    required
                  />
                  <div className="d-flex justify-content-between text-muted mt-1" style={{ fontSize: "11px" }}>
                    <span>{errors.title && <span style={{ color: "red" }}>â›” {errors.title}</span>}</span>
                    <span>{formData.title.length}/100</span>
                  </div>
                </Col>
                {/* 8. Description */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Description / Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    placeholder="Type details or important notes about the topics covered in this lecture..."
                    style={{ ...inputStyle, height: "auto" }}
                    value={formData.description}
                    onChange={this.handleFieldChange}
                    maxLength={1500}
                  />
                  <div className="d-flex justify-content-between text-muted mt-1" style={{ fontSize: "11px" }}>
                    <span>{errors.description && <span style={{ color: "red" }}>â›” {errors.description}</span>}</span>
                    <span>{(formData.description || "").length}/1500</span>
                  </div>
                </Col>
                {/* 5 & 6. Category & Sub Category */}
                <Col md={6} className="mb-3">
                  <Form.Label style={labelStyle}>Lecture Category *</Form.Label>
                  <Form.Control
                    as="select"
                    name="video_category_id"
                    style={inputStyle}
                    value={formData.video_category_id}
                    onChange={this.handleFieldChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                      <option key={c.id} value={c.id}>{c.video_category}</option>
                    ))}
                  </Form.Control>
                  {errors.video_category_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.video_category_id}</p>
                  )}
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label style={labelStyle}>Lecture Sub Category *</Form.Label>
                  <Form.Control
                    as="select"
                    name="video_sub_category_id"
                    style={inputStyle}
                    value={formData.video_sub_category_id}
                    onChange={this.handleFieldChange}
                    disabled={!formData.video_category_id}
                    required
                  >
                    <option value="">Select Sub Category</option>
                    {filteredSubCategories.map((sub) => (
                      <option key={sub.id} value={sub.id}>{sub.video_sub_category}</option>
                    ))}
                  </Form.Control>
                  {errors.video_sub_category_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.video_sub_category_id}</p>
                  )}
                </Col>
                <Col md={12} className="mb-4 mt-2">
                  <div className="mb-3 d-flex align-items-center">
                    <div style={{ background: "#eff6ff", color: "#4f46e5", width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                      <i className="fal fa-video" style={{ fontSize: "16px" }} />
                    </div>
                    <h6 style={{ margin: 0, fontWeight: "800", color: "#111827", fontSize: "15px" }}>Lecture Video</h6>
                  </div>
                  {/* Video Preview / Dropzone */}
                  {this.state.videoFile ? (
                    <div style={{ border: `1px solid ${THEME.border}`, borderRadius: "12px", background: "#fff", marginBottom: "16px", overflow: "hidden" }}>
                      {/* Video Preview Player â€” always visible */}
                      <div style={{ background: "#000", position: "relative" }}>
                        <video
                          src={this.state.videoPreviewUrl}
                          controls
                          style={{ width: "100%", maxHeight: "220px", display: "block" }}
                        />
                      </div>
                      {/* File Info */}
                      <div style={{ padding: "12px 16px", display: "flex", alignItems: "center" }}>
                        <div style={{ background: "#e0e7ff", width: "36px", height: "36px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                          <i className="fal fa-file-video" style={{ fontSize: "16px", color: THEME.primary }} />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <span style={{ display: "block", fontSize: "12px", fontWeight: "700", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {this.state.videoFile.name}
                          </span>
                          <span style={{ fontSize: "11px", color: THEME.textMuted }}>
                            {(this.state.videoFile.size / (1024 * 1024)).toFixed(2)} MB
                          </span>
                        </div>
                        {/* Only allow remove when NOT uploading */}
                        {(videoUploadProgress === null || videoUploadProgress === 100) && !formData.video_url && (
                          <button
                            onClick={() => {
                              if (this.state.videoPreviewUrl) URL.revokeObjectURL(this.state.videoPreviewUrl);
                              this.setState({ videoFile: null, videoPreviewUrl: null, videoUploadProgress: null });
                            }}
                            style={{ background: "none", border: "none", color: THEME.danger, padding: "4px", cursor: "pointer", fontSize: "16px" }}
                            title="Remove Video"
                          >
                            <i className="fal fa-times-circle" />
                          </button>
                        )}
                      </div>
                      {/* Inline Upload Status Section */}
                      <div style={{ padding: "0 16px 14px 16px" }}>
                        {videoUploadProgress === null && !formData.video_url && (
                          /* Not yet uploaded â€” show Upload button */
                          <Button
                            type="button"
                            onClick={this.uploadVideoToR2}
                            style={{
                              background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                              border: "none",
                              borderRadius: "8px",
                              padding: "10px",
                              fontWeight: "700",
                              fontSize: "13px",
                              width: "100%",
                            }}
                          >
                            <i className="fal fa-cloud-upload mr-2" /> Upload Video
                          </Button>
                        )}
                        {videoUploadProgress !== null && videoUploadProgress < 100 && (
                          /* Uploading â€” show progress bar + cancel */
                          <div>
                            <div className="d-flex justify-content-between mb-1" style={{ fontSize: "11px", fontWeight: "700", color: THEME.text }}>
                              <span><i className="fal fa-upload mr-1" /> Uploading...</span>
                              <span>{videoUploadProgress}%</span>
                            </div>
                            <div style={{ background: "#e2e8f0", borderRadius: "8px", height: "10px", overflow: "hidden", marginBottom: "10px" }}>
                              <div style={{ background: "linear-gradient(90deg, #6366f1 0%, #4f46e5 100%)", width: `${videoUploadProgress}%`, height: "100%", transition: "width 0.2s ease" }} />
                            </div>
                            <Button
                              type="button"
                              variant="outline-danger"
                              size="sm"
                              onClick={this.cancelVideoUpload}
                              style={{ width: "100%", fontWeight: "700", borderRadius: "8px", fontSize: "12px" }}
                            >
                              <i className="fal fa-times-circle mr-1" /> Cancel Upload
                            </Button>
                          </div>
                        )}
                        {formData.video_url && (
                          /* Upload complete â€” show success status */
                          <div style={{ display: "flex", alignItems: "center", padding: "10px 0 0 0" }}>
                            <div style={{ background: "#dcfce7", width: "28px", height: "28px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px", flexShrink: 0 }}>
                              <i className="fal fa-check" style={{ fontSize: "14px", color: THEME.success }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span style={{ display: "block", fontSize: "12px", fontWeight: "700", color: THEME.success }}>Uploaded successfully</span>
                            </div>
                            <button
                              type="button"
                              onClick={() => this.setState(prev => ({ formData: { ...prev.formData, video_url: "" }, videoFile: null, videoUploadProgress: null }))}
                              style={{ background: "none", border: "none", color: THEME.danger, padding: "4px", cursor: "pointer", fontSize: "14px" }}
                              title="Remove & Re-upload"
                            >
                              <i className="fal fa-times-circle" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : formData.video_url ? (
                    /* Video was uploaded in a previous session (edit mode) â€” no local file, just the stored key */
                    <div style={{ padding: "16px", border: `1px solid ${THEME.border}`, borderRadius: "12px", background: "#f0fdf4", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                      <div style={{ background: "#dcfce7", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                        <i className="fal fa-check-circle" style={{ fontSize: "20px", color: THEME.success }} />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ display: "block", fontSize: "13px", fontWeight: "700", color: THEME.success }}>
                          Video Stored Securely
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={() => this.setState(prev => ({ formData: { ...prev.formData, video_url: "" } }))}
                        style={{ background: "none", border: "none", color: THEME.danger, padding: "4px", cursor: "pointer", fontSize: "16px" }}
                        title="Remove Existing Video"
                      >
                        <i className="fal fa-times-circle" />
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        border: `2px dashed ${THEME.border}`,
                        borderRadius: "12px",
                        padding: "24px 16px",
                        textAlign: "center",
                        background: THEME.bgLight,
                        cursor: "pointer",
                        position: "relative",
                        transition: "all 0.2s ease",
                        marginBottom: "16px",
                      }}
                      onDragOver={this.handleVideoDragOver}
                      onDragLeave={this.handleVideoDragLeave}
                      onDrop={this.handleVideoDrop}
                      onClick={() => this.fileInput && this.fileInput.click()}
                    >
                      <input
                        ref={(r) => (this.fileInput = r)}
                        type="file"
                        accept="video/*"
                        style={{ display: "none" }}
                        onChange={this.handleVideoDrop}
                      />
                      <i className="fal fa-cloud-upload" style={{ fontSize: "36px", color: THEME.primary, marginBottom: "10px" }} />
                      <span style={{ fontSize: "12px", fontWeight: "700", color: THEME.text, display: "block" }}>Select MP4 Video File</span>
                      <span style={{ fontSize: "10px", color: THEME.textMuted, marginTop: "4px", display: "block" }}>Drag & drop or click to browse</span>
                    </div>
                  )}
                  {errors.video_url && (
                    <div style={{ background: "#fef2f2", border: "1px solid #f87171", color: "#dc2626", padding: "8px 12px", borderRadius: "8px", fontSize: "12px", marginTop: "10px", display: "flex", alignItems: "center", fontWeight: "600" }}>
                      <i className="fal fa-exclamation-triangle mr-2" style={{ fontSize: "14px" }} />
                      {errors.video_url}
                    </div>
                  )}
                </Col>
                <Col md={12} className="mb-3">
                  {/* PDF Document attachment */}
                  <div className="mb-3 d-flex align-items-center">
                    <div style={{ background: "#eff6ff", color: THEME.primary, width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                      <i className="fal fa-paperclip" style={{ fontSize: "16px" }} />
                    </div>
                    <h6 style={{ margin: 0, fontWeight: "800", color: THEME.text, fontSize: "15px" }}>Notes / Lecture Handout</h6>
                  </div>
                  {this.state.docFileObject ? (
                    <div style={{ padding: "16px", border: `1px solid ${THEME.border}`, borderRadius: "12px", background: "#fff", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                      <div style={{ background: "#fee2e2", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                        <i className="fas fa-file-pdf" style={{ fontSize: "20px", color: "#dc2626" }} />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ display: "block", fontSize: "13px", fontWeight: "700", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {this.state.docFileObject.name}
                        </span>
                        <span style={{ fontSize: "11px", color: THEME.textMuted }}>
                          {(this.state.docFileObject.size / (1024 * 1024)).toFixed(2)} MB Pending Upload
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={() => this.setState({ docFileObject: null })}
                        style={{ background: "none", border: "none", color: THEME.danger, padding: "4px", cursor: "pointer", fontSize: "16px" }}
                        title="Remove Document"
                      >
                        <i className="fal fa-times-circle" />
                      </button>
                    </div>
                  ) : formData.doc_file ? (
                    <div style={{ padding: "16px", border: `1px solid ${THEME.border}`, borderRadius: "12px", background: "#f0fdf4", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                      <div style={{ background: "#dcfce7", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                        <i className="fal fa-check-circle" style={{ fontSize: "20px", color: THEME.success }} />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ display: "block", fontSize: "13px", fontWeight: "700", color: THEME.success }}>
                          Document Attached
                        </span>
                        <span style={{ fontSize: "11px", color: THEME.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>
                          {formData.doc_file.split('/').pop()}
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={() => this.setState(prev => ({ formData: { ...prev.formData, doc_file: "" } }))}
                        style={{ background: "none", border: "none", color: THEME.danger, padding: "4px", cursor: "pointer", fontSize: "16px" }}
                        title="Remove Existing Document"
                      >
                        <i className="fal fa-times-circle" />
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        border: `2px dashed ${THEME.border}`,
                        borderRadius: "12px",
                        padding: "16px",
                        textAlign: "center",
                        background: THEME.bgLight,
                        cursor: "pointer",
                        position: "relative",
                        marginBottom: "16px",
                      }}
                      onClick={() => this.docFileInput && this.docFileInput.click()}
                    >
                      <input
                        ref={(r) => (this.docFileInput = r)}
                        type="file"
                        accept=".pdf,.doc,.docx"
                        style={{ display: "none" }}
                        onChange={this.handleDocFileChange}
                      />
                      {docUploading ? (
                        <Spinner animation="border" size="sm" variant="primary" />
                      ) : (
                        <>
                          <i className="fal fa-file-pdf" style={{ fontSize: "28px", color: THEME.textMuted, marginBottom: "6px" }} />
                          <span style={{ fontSize: "12px", fontWeight: "700", color: THEME.text, display: "block" }}>Attach PDF Document</span>
                          <span style={{ fontSize: "9px", color: THEME.textMuted, display: "block" }}>Under 5MB size limit</span>
                        </>
                      )}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
            {/* Right Column - Categorization & Settings */}
            <Col lg={5} md={5} className="pl-lg-4 mt-4 mt-md-0" style={{ borderLeft: "1px solid #e2e8f0" }}>
              <div className="mb-4 d-flex align-items-center">
                <div style={{ background: "#f0fdf4", color: "#16a34a", width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                  <i className="fal fa-cogs" style={{ fontSize: "16px" }} />
                </div>
                <h6 style={{ margin: 0, fontWeight: "800", color: "#111827", fontSize: "15px" }}>Settings & Assignment</h6>
              </div>
              <Row>
                {/* 1. Branch */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Branch *</Form.Label>
                  <Form.Control
                    as="select"
                    name="branch_id"
                    style={inputStyle}
                    value={formData.branch_id}
                    onChange={this.handleFieldChange}
                    required
                  >
                    <option value="">Select Branch </option>
                    {branches.map((b) => (
                      <option key={b.id} value={b.id}>{b.branch_name}</option>
                    ))}
                  </Form.Control>
                  {errors.branch_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.branch_id}</p>
                  )}
                </Col>
                {/* 2. Class */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Class *</Form.Label>
                  <Form.Control
                    as="select"
                    name="class_id"
                    style={inputStyle}
                    value={formData.class_id}
                    onChange={this.handleFieldChange}
                    required
                  >
                    <option value="">Select Class</option>
                    {this.getFilteredClasses().map((c) => (
                      <option key={c.id} value={c.id}>{c.class}</option>
                    ))}
                  </Form.Control>
                  {errors.class_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.class_id}</p>
                  )}
                </Col>
                {/* 3. Subject */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Subject *</Form.Label>
                  <Form.Control
                    as="select"
                    name="subject_id"
                    style={inputStyle}
                    value={formData.subject_id}
                    onChange={this.handleFieldChange}
                    disabled={!formData.class_id}
                    required
                  >
                    <option value="">Select Subject</option>
                    {filteredSubjects.map((s) => (
                      <option key={s.id} value={s.id}>{s.subject}</option>
                    ))}
                  </Form.Control>
                  {errors.subject_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.subject_id}</p>
                  )}
                </Col>
                {/* 4. Lecturer */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Lecturer / Employee *</Form.Label>
                  <Form.Control
                    as="select"
                    name="lecturer_id"
                    style={inputStyle}
                    value={formData.lecturer_id}
                    onChange={this.handleFieldChange}
                    disabled={!formData.subject_id}
                    required
                  >
                    <option value="">Select Lecturer</option>
                    {filteredLecturers.map((l) => (
                      <option key={l.employeeId} value={l.employeeId}>{l.employee_name}</option>
                    ))}
                  </Form.Control>
                  {errors.lecturer_id && (
                    <p style={{ color: "red", fontSize: 11, marginTop: 4 }}>â›” {errors.lecturer_id}</p>
                  )}
                </Col>
                {/* 9. Video Date */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Video Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="video_date"
                    style={inputStyle}
                    value={formData.video_date}
                    onChange={this.handleFieldChange}
                    required
                  />
                </Col>
                {/* 10. Other Status */}
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Paid Video? *</Form.Label>
                  <Form.Check
                    type="switch"
                    id="paid_video_switch"
                    label={formData.paid_video === 1 ? "Paid" : "Free"}
                    checked={formData.paid_video === 1}
                    onChange={(e) => this.handleFieldChange({ target: { name: 'paid_video', value: e.target.checked ? 1 : 0 } })}
                    style={{ fontWeight: "600", fontSize: "14px", color: THEME.text }}
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label style={labelStyle}>Publish Status *</Form.Label>
                  <Form.Check
                    type="switch"
                    id="publish_switch"
                    label={formData.publish === 1 ? "Yes (Publish)" : "No (Save Draft)"}
                    checked={formData.publish === 1}
                    onChange={(e) => this.handleFieldChange({ target: { name: 'publish', value: e.target.checked ? 1 : 0 } })}
                    style={{ fontWeight: "600", fontSize: "14px", color: THEME.text }}
                  />
                </Col>
              </Row>
              {/* Form Action buttons */}
              {errors.submit && (
                <div style={{ color: "red", fontSize: 13, marginTop: 10, textAlign: "center", fontWeight: "bold" }}>
                  â›” {errors.submit}
                </div>
              )}
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "24px" }}>
                <Button
                  type="submit"
                  disabled={saving || (videoUploadProgress !== null && videoUploadProgress < 100)}
                  style={{
                    background: (saving || (videoUploadProgress !== null && videoUploadProgress < 100))
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px",
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  {saving ? (
                    <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" /> Saving...</>
                  ) : (videoUploadProgress !== null && videoUploadProgress < 100) ? (
                    <><i className="fal fa-lock mr-2" /> Uploading Video...</>
                  ) : (
                    <><i className="fal fa-save mr-2" /> {editItem ? "Update Lecture Video" : "Save Lecture Video"}</>
                  )}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
export default LectureUpload;
